export const HeartbeatNotification = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: "12px" }}
    >
      <path
        d="M15.36 8.18109H13.2262L11.7901 4.73469C11.6845 4.48125 11.4266 4.327 11.1565 4.34237C10.8839 4.36094 10.6522 4.55103 10.5818 4.81597L8.71297 11.8221L6.70591 2.28862C6.64766 2.01278 6.416 1.80734 6.13503 1.78303C5.85216 1.75169 5.59041 1.92062 5.48606 2.1824L3.08669 8.1805H0.64C0.286719 8.1805 0 8.46722 0 8.8205C0 9.17444 0.286719 9.4605 0.64 9.4605H3.52C3.78175 9.4605 4.01728 9.30112 4.11456 9.05794L5.88928 4.62081L8.01409 14.7123C8.07491 15.0022 8.32706 15.2122 8.62337 15.2205C8.6285 15.2205 8.63425 15.2205 8.64 15.2205C8.92928 15.2205 9.184 15.0259 9.25825 14.7462L11.3331 6.96512L12.2093 9.06753C12.3085 9.30562 12.5421 9.46112 12.8 9.46112H15.36C15.7139 9.46112 16 9.17503 16 8.82112C16 8.46781 15.7139 8.18109 15.36 8.18109Z"
        fill="#2469F3"
      />
    </svg>
  );
}